import React from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Table,
  Label,
  Input,
  Alert,
} from 'reactstrap';
import { toast } from 'react-toastify';
import ActionButton from '../../../../../Components/Common/ActionButton';

import * as api from '../procurementApi';

const INFO_TEXT =
  'All Registered Supplier list that will be generated are the result of data retrieval from ' +
  'the ERS Application with parameters Crude & Condensate as Cargo Category, ' +
  'Supplier, and Tender Invitation. and will be attached to the memo or Nota ' +
  'Dinas Izin Refinery and Hydrocarbon Procurement.';

const SLIDER_LABEL =
  'The list of Business Partners displayed in the Registered Supplier table are Business ' +
  'Partners who will be invited and/or accept the invitation, and will be ' +
  'attached to the memo or Nota Dinas Izin Refinery dan Hydrocarbon Procurement';

// Procurement > DMUT Invitation tab — VIEW ONLY.
//
// The DMUT list (who will be invited) was selected during Planning; here it is
// shown read-only. Only the invited partners are listed. Download fetches the
// server-generated Excel (contract §10) built from the saved PlanningDmutList
// (3 columns: DMUT Name / PIC Name / PIC Email) — no live eRS call.
const ProcurementDmutView = ({ detail, procurementValidityId }) => {
  const dmut = detail.dmut || { rows: [] };
  const invited = (dmut.rows || []).filter(r => r.invited);

  const handleDownload = async () => {
    if (!invited.length)
      return toast.info('No Registered Supplier to download');
    try {
      const blob = await api.downloadDmutInvitation(procurementValidityId);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `DmutList_${Date.now()}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error(`Download failed: ${error}`);
    }
  };

  return (
    <div>
      <Alert color='info' className='d-flex'>
        <i className='ri-information-line fs-16 me-2'></i>
        <span>{INFO_TEXT}</span>
      </Alert>

      <Card className='border shadow-none'>
        <CardBody>
          <div className='form-check form-switch mb-3'>
            <Input
              type='checkbox'
              role='switch'
              className='form-check-input'
              checked={!!dmut.confirmed}
              disabled
              readOnly
            />
            <Label className='form-check-label'>{SLIDER_LABEL}</Label>
          </div>

          <div className='d-flex gap-2 flex-wrap'>
            <ActionButton
              variant='secondary'
              icon='ri-file-excel-2-line'
              disabled={!invited.length}
              onClick={handleDownload}
            >
              Download Registered Supplier
            </ActionButton>
          </div>
        </CardBody>
      </Card>

      <Card className='border shadow-none'>
        <CardHeader className='fw-semibold bg-light'>
          Registered Supplier List
        </CardHeader>
        <CardBody className='p-0'>
          <div className='table-responsive'>
            <Table className='align-middle table-nowrap mb-0'>
              <thead className='table-light'>
                <tr className='text-uppercase fs-12 text-muted'>
                  <th style={{ width: 60 }}>No</th>
                  <th>Nama Perusahaan Vendor (Registered Supplier)</th>
                  <th>Nama PIC</th>
                  <th>Email PIC Contact</th>
                  <th>Status Undangan</th>
                </tr>
              </thead>
              <tbody>
                {!invited.length ? (
                  <tr>
                    <td colSpan={5} className='text-center text-muted py-3'>
                      No Registered Supplier invited
                    </td>
                  </tr>
                ) : (
                  invited.map((r, idx) => (
                    <tr key={r.id}>
                      <td className='text-muted'>{idx + 1}</td>
                      <td>
                        <i className='ri-building-line text-muted me-2'></i>
                        <span className='fw-semibold'>{r.name}</span>
                      </td>
                      <td>{r.picName}</td>
                      <td>
                        <span className='font-monospace text-primary fs-12'>
                          {r.picEmail}
                        </span>
                      </td>
                      <td>
                        <span className='badge rounded-pill bg-success-subtle text-success border border-success-subtle'>
                          <i className='ri-checkbox-circle-line me-2'></i>
                          Invited
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default ProcurementDmutView;
